import { render, staticRenderFns } from "./MainMobileNavigation.vue?vue&type=template&id=2a84951a"
import script from "./MainMobileNavigation.vue?vue&type=script&lang=js"
export * from "./MainMobileNavigation.vue?vue&type=script&lang=js"
import style0 from "./MainMobileNavigation.vue?vue&type=style&index=0&id=2a84951a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports